import * as React from 'react';
var Image = function (_a) {
    var width = _a.width, height = _a.height, imageName = _a.imageName;
    return (imageName && (React.createElement("img", { width: width, height: height, src: require("../../assets/icons/" + imageName.replace(/:/g, '').split('.')[0] + ".png") })));
};
export default Image;
//# sourceMappingURL=index.js.map